const progress_list = [
  {
    num1: 0,
    name1: '本期读数',
    icon: '－',
    num2: 0,
    name2: '上期读数',
    num3: 0,
    name3: '总能耗'
  },
  {
    num1: 0,
    name1: '总能耗',
    icon: '÷',
    num2: 0,
    name2: '均摊人数',
    num3: 0,
    name3: '人均能耗'
  },
  {
    num1: 0,
    name1: '人均能耗',
    icon: '×',
    num2: 0,
    name2: '个人单价',
    num3: 0,
    name3: '每人应交'
  },
  {
    num1: 0,
    name1: '每人应交',
    icon: '×',
    num2: 0,
    name2: '缴费人数',
    num3: 0,
    name3: '账单应交'
  }
]

function getMoney(item) {
  // console.log(item)
  const format = value => parseFloat(value).toFixed(2);

  let           this_num = parseFloat(item.this_num || 0), last_num = parseFloat(item.last_num || 0);
  progress_list[0].num1  = this_num;
  progress_list[0].num2  = last_num;

  let sum1 = this_num - last_num;
  let sum1Format = format(sum1);
  progress_list[0].num3 = sum1Format;
  progress_list[1].num1 = sum1Format;
  item.fee_total_num = item.fee_total_num || 1;
  let sum2 = format(sum1 / item.fee_total_num);
  progress_list[1].num2 = item.fee_total_num;
  progress_list[1].num3 = sum2;
  progress_list[2].num1 = sum2;

  let price = item.price;
  let sum3 = format(sum2 * price);
  progress_list[2].num2 = price;
  progress_list[2].num3 = sum3;
  progress_list[3].num1 = sum3;

  item.fee_paynum = item.fee_paynum || 1;
  let sum4 = format(sum3 * item.fee_paynum);
  progress_list[3].num2 = item.fee_paynum;
  progress_list[3].num3 = sum4;

  // console.log(sum4)
  return {total: sum4, init_diff: sum1Format, progress_list};
}

function encodeRouteData(data) {
  try {
    return encodeURIComponent(JSON.stringify(data));
  } catch (e) {
    return '';
  }
}

function parseRouteData(raw, defaultValue = {}) {
  if (!raw) {
    return defaultValue;
  }
  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch (e) {
    try {
      return JSON.parse(raw);
    } catch (err) {
      return defaultValue;
    }
  }
}

import wx from 'weixin-js-sdk';
import {post} from '@/common/js/http'
import {IsWeiXin} from '@/common/js/login'

function configShare() {
  let url = window.location.href;
  if(url.includes('/#/')){
    url=url.replace('/#/','/?#/');
    window.location.href=url;
  }

  let params = {
    url
  }
  console.log(params)
  post('user/getWXsign', params).then(res => {
    // console.log(res)
    if (res.code == 1) {
      let data = res.data;
      wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData','onMenuShareAppMessage','onMenuShareTimeline'],
        openTagList: ['wx-open-launch-weapp'] // 跳转小程序时必填
      });
      sessionStorage.setItem('config_data', JSON.stringify(data));
      toShare();
    } 
  })
};

function toShare() {
  let config_data = JSON.parse(sessionStorage.getItem('config_data'));

  let share_data = JSON.parse(sessionStorage.getItem('share_data')) || {};
  if (Object.keys(share_data).length) {
    config_data = {...config_data, ...share_data};
  }
  console.log(config_data, '值')
  wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    wx.updateAppMessageShareData({
      title: config_data.title, // 分享标题
      desc: config_data.desc, // 分享描述
      link: config_data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: config_data.logo, // 分享图标
      success: function () {
        console.log('成功')
      },
    })

    wx.updateTimelineShareData({
      title: config_data.title, // 分享标题
      link: config_data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: config_data.logo, // 分享图标
    })
  });
}

function toPay(data,fn) {
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    onBridgeReady(data,fn);
  }
}

function onBridgeReady(data,fn) {
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest', data,
    function (res) {
      console.log(res);
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        fn&&fn();
      }
    });
}
// 动态生成标签
// info参数
/* 
let params={
  eleId:"", // 元素ID
  username:"", // 小程序id号 gh_****
  url:"", // 跳转小程序的页面路径地址 例: pages/home/home.html - (后面必须带上.html后缀 否则IOS跳转时出现小程序页面未配置)
  content:"" // html字符串 例: "<button>点我</button>"
}
*/
function wx_launch(info){
  if (!IsWeiXin()) {
    return
  }else{
      var btn = document.getElementById(info.eleId); //获取元素
      let script = document.createElement("script");// 创建script内容插槽 避免template标签冲突
      script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
      script.text = info.content // 自定义的html字符串内容
      let html = `<wx-open-launch-weapp username="${info.username}" path="${info.url}">${script.outerHTML}</wx-open-launch-weapp>`;
      btn.innerHTML = html; // html字符串赋值
      // 点击按钮 正常跳转触发
      btn.addEventListener("launch", function (e) {
        console.log("success");
      });
      // 点击跳转 抛出异常
      btn.addEventListener("error", function (e) {
        console.log("fail", e.detail);
        alert(`跳转异常 - ${e.detail}`)
      });
  }
  
}
export {
  getMoney,
  encodeRouteData,
  parseRouteData,
  configShare,
  toShare,
  toPay,
  wx_launch
}



// WEBPACK FOOTER //
// ./src/common/js/common.js